import { h, Component } from 'preact';

import './index.less';

class RequestIdentityChatBubble extends Component {
  render () {
    const {
      MESSAGE_TYPE,
      name,
      message,
      type,
      color,
      textColor = '',
      messageBackgroundColor = '',
      messageBoxShadow = ''
    } = this.props;

    return (
      <div
        className={`chat-bubble-container ${type === MESSAGE_TYPE.OTHER ? 'left-align' : ''} ${
          type === MESSAGE_TYPE.SELF ? 'right-align' : ''
        }`}
      >
        {type === MESSAGE_TYPE.OTHER ? (
          <div
            style={{ borderColor: `transparent ${messageBackgroundColor}` }}
            className={'chat-bubble-left-arrow'}
          >
            {''}
          </div>
        ) : null}
        <div
          style={{
            backgroundColor: messageBackgroundColor,
            boxShadow: messageBoxShadow
          }}
          className={`${type === MESSAGE_TYPE.OTHER ? 'chat-bubble-left' : ''} ${
            type === MESSAGE_TYPE.SELF ? 'chat-bubble-right' : ''
          } ${color === 'white' ? 'white' : ''}`}
        >
          <div className="name" style={{ color: textColor }}>
            {name}
          </div>
          <div className="message" style={{ color: textColor }}>
            {message}
          </div>
        </div>
        {type === MESSAGE_TYPE.SELF ? (
          <div
            style={{ borderColor: `transparent ${messageBackgroundColor}` }}
            className={'chat-bubble-right-arrow'}
          >
            {''}
          </div>
        ) : null}
      </div>
    );
  }
}

export default RequestIdentityChatBubble;
